import React, { useState, useEffect, useContext, useMemo } from "react";
import { Col, Container, Row } from "react-bootstrap";
import URLstateContext from "../../../provider/CommonContext";
import {
  GetMethodData,
  DecryptAESdata,
  GetPostMethodData,
} from "../../../provider/ServiceProvider";
import * as XLSX from "xlsx";
//import Pagination from "../../CommonUI/Pagination/Pagination";
// import Pagination from "https://cdn.skypack.dev/rc-pagination@3.1.15";
import execl from "../../../images/excel.png";
// import Pagination from 'rc-pagination';
import { Pagination } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Vortex } from "react-loader-spinner";
import animation from "../../../images/jm-animation.gif";

function NavHistory() {
  const dayjs = require("dayjs");
  const currentDate = dayjs();
  const lastMonthDate = currentDate.subtract(1, "day").subtract(1, "month");
  const lastMonthDateFormatted = lastMonthDate.format("YYYY-MM-DD");
  const [dataDropFund, setDataDropdownFund] = useState("");
  const [DropdownFundCode, setDataDropdownFundCode] = useState("");
  const [DropdownFundType, setDataDropdownFundType] = useState("");
  const [valuedate, setValuedate] = useState(dayjs());
  const [StartDate, setStartDate] = useState(dayjs(lastMonthDateFormatted));
  const [valuedatelatest, setValuedateLatest] = useState("");
  const [data, setData] = useState("");
  const [dataDrop, setDataDropdown] = useState("");
  const [values, setValues] = useState("Equity");
  const [Valuesdrop, setValuesdrop] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [size, setSize] = useState(perPage);
  const [current, setCurrent] = useState(1);
  const [endDate, setlastDate] = useState("");
  const [loadingshow, setloadingshow] = useState(false);
  //  alert(Valuesdrop)
  const { BaseURL, BaseURLShare } = useContext(URLstateContext);
  let PageSize = size;
  const [selectedOptionFundCode, setSelectedOption] = useState("");
  const [showAdditionalDropdowns, setShowAdditionalDropdowns] = useState(false);
  const [optiondesc, setSelectedOptionOptionDesc] = useState("");
  const [showAdditionalDropdowns2, setShowAdditionalDropdowns2] =
    useState(false);
  const [selectedOptionFundtype, setSelectedOptionFundCode] = useState("");
  const [showAdditionalDropdowns1, setShowAdditionalDropdowns1] =
    useState(false);
  const [activeTab, setActiveTab] = useState("Equity");

  const handleChangeFundName = (event) => {
    // setData('')
    document.getElementById("datedrop").style.display = "block";
    const selectedValue = event.target.value;
    setSelectedOption(selectedValue);
    if (selectedValue !== "") {
      setShowAdditionalDropdowns(true);
    } else {
      setShowAdditionalDropdowns(false);
    }
  };

  const handleChangeFundCode = (event) => {
    setData("");
    const selectedValue = event.target.value;
    setSelectedOptionFundCode(selectedValue);
    if (selectedValue !== "") {
      setShowAdditionalDropdowns1(true);
    } else {
      setShowAdditionalDropdowns1(false);
    }
  };

  const handleChangeOptiinDesc = (event) => {
    setData("");
    const selectedValue = event.target.value;
    setSelectedOptionOptionDesc(selectedValue);
    if (selectedValue !== "") {
      setShowAdditionalDropdowns2(true);
    } else {
      setShowAdditionalDropdowns2(false);
    }
  };
  useEffect(() => {
    setSelectedOptionFundCode("");
  }, [selectedOptionFundCode]);

  useEffect(() => {
    setloadingshow(true);
    GetPostMethodData(BaseURL + "GetNavDetailsDrop", {
      IVPage: "NAV",
      type: values,
      IVFundCode: "",
      IVPlanType: "",
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setDataDropdownFund(DecryptAESdata(data.data));
        setloadingshow(false);
      }
    });

    GetPostMethodData(BaseURL + "GetNavDetailsDrop", {
      IVPage: "NAV",
      type: values,
      IVFundCode: selectedOptionFundCode,
      IVPlanType: "",
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setDataDropdownFundCode(DecryptAESdata(data.data));
        setloadingshow(false);
        //console.log(DecryptAESdata(data.data), "dropFundcode")
      }
    });

    GetPostMethodData(BaseURL + "GetNavDetailsDrop", {
      IVPage: "NAV",
      type: values,
      IVFundCode: selectedOptionFundCode,
      IVPlanType: selectedOptionFundtype,
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setDataDropdownFundType(DecryptAESdata(data.data));
        setloadingshow(false);

        // console.log(DecryptAESdata(data.data), "dropFundtype")
      }
      // if(selectedOptionFundtype != ""){
      //     document.getElementsByClassName('btn-go-nav').style.display = "block";
      // }
    });
  }, [BaseURL, values, selectedOptionFundCode, selectedOptionFundtype]);

  useEffect(() => {
    document.getElementById("datedrop").style.display = "none";
    const dateString = dayjs(valuedate).format("YYYY-MM-DD");
    const dateStringLast = dayjs(StartDate).format("YYYY-MM-DD");
    setTimeout(() => {
      setloadingshow(true);
      GetPostMethodData(BaseURL + "GetNavHistory", {
        type: values,
        IVFundCode: "",
        IVPlanType: "",
        IVSchemeCode: "",
        IDstartdate: dateStringLast,
        IDenddate: dateString,
      }).then((data) => {
        if (data.data != null && data.data.length > 0) {
          setData(DecryptAESdata(data.data));
          console.log("GetNavHistory====>", DecryptAESdata(data.data));
          setloadingshow(false);
        } else {
          setData("");
          setloadingshow(false);
        }
      });
    }, 1000);
  }, [BaseURL, values]);

  // useEffect(() => {
  //     setloadingshow(true);
  //     GetPostMethodData(BaseURL + "GetNavDetailsDrop", {
  //         "IVpagename": "hist",
  //         "type": values,

  //     }).then((data) => {
  //         if (data.data != null && data.data.length > 0) {
  //             setDataDropdown(DecryptAESdata(data.data))
  //             // console.log(DecryptAESdata(data.data),"drop")

  //             setloadingshow(false);

  //         }
  //     });
  // }, [BaseURL, values]);

  // const handleChange = (e) => {
  //     const valueLi = e.currentTarget.getAttribute("data-value")
  //     setValues(valueLi)
  // }
  const handleChange = (e) => {
    e.preventDefault();
    const valueLi = e.currentTarget.getAttribute("data-value");
    setValues(valueLi);
    setActiveTab(valueLi);
    setValuesdrop("");
    setShowAdditionalDropdowns(false);
    setSelectedOptionOptionDesc("");
    setData("");
    setSelectedOption("");
  };
  const columns = [
    { label: "Scheme Code", value: "SchemeCode" },
    { label: "Category Id", value: "categoryid" },
    { label: "Scheme Name", value: "scheme_name" },
    { label: "NAV Date", value: "navdate" },
    { label: "NAV", value: "Nav" },
    // { label: 'Corporate IDCW', value: 'CorpDiv' },
    // { label: 'Individual IDCW', value: 'NonCorpDiv' },
  ];

  function exportToExcel(data, columns) {
    const dataNew = data.map((item) => {
      const dataItem = {};
      columns.forEach((column) => {
        dataItem[column.label] = item[column.value];
      });
      return dataItem;
    });
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(dataNew);
    const columnWidths = [
      { wch: 11 },
      { wch: 9 },
      { wch: 50 },
      { wch: 12 },
      { wch: 12 },
      { wch: 15 },
      { wch: 15 },
    ];
    worksheet["!cols"] = columnWidths;
    const cellNumberFormat = "#,##0.00";
    const cell = XLSX.utils.encode_cell({ r: 0, c: 0 });
    worksheet[cell].z = cellNumberFormat;
    XLSX.utils.book_append_sheet(workbook, worksheet, "HistoricalNav");
    XLSX.writeFile(workbook, "HistoricalNav.xlsx");
  }
  const currentTableData = useMemo(() => {
    if (data != null) {
      const firstPageIndex = (current - 1) * PageSize;
      const lastPageIndex = firstPageIndex + PageSize;
      if (data != null) {
        if (data.length > 0) {
          // return data.slice(firstPageIndex, lastPageIndex);
          return data.slice((current - 1) * PageSize, current * PageSize);
        }
      }
    }
  }, [current, data, PageSize]);

  const PaginationChange = (page, pageSize) => {
    setCurrent(page);
    setSize(pageSize);
  };

  const PrevNextArrow = (current, type, originalElement) => {
    if (type === "prev") {
      return (
        
          <i className="fa fa-angle-double-left"></i>
        
      );
    }
    if (type === "next") {
      return (
  
          <i className="fa fa-angle-double-right"></i>
       
      );
    }
    return originalElement;
  };
  const handleChangedate = (StartDatenew) => {
    const datestart = dayjs(StartDatenew).format("YYYY-MM-DD");
    setValuedateLatest(datestart);
    // alert(datestart, "datestart")
  };

  const isDateInFuture = (date) => {
    return dayjs(date).isAfter(dayjs(), "day");
  };
  const handleChangedateEnd = (newValue) => {
    const val = dayjs(newValue).format("YYYY-MM-DD");
    setlastDate(val);
  };

  const buttonGo = () => {
    setCurrent(1);
    const dateString = dayjs(valuedate).format("YYYY-MM-DD");
    const dateStringLast = dayjs(StartDate).format("YYYY-MM-DD");

    if (
      selectedOptionFundCode != "" &&
      values != "" &&
      selectedOptionFundtype != "" &&
      optiondesc != ""
    ) {
      const apiParams = {
        type: values,
        IVFundCode: selectedOptionFundCode,
        IVPlanType: selectedOptionFundtype,
        IVSchemeCode: optiondesc,
      };
      if (valuedatelatest !== "" && endDate !== "") {
        if (dayjs(endDate).isAfter(dayjs(valuedatelatest))) {
          apiParams.IDstartdate = valuedatelatest;
          apiParams.IDenddate = endDate;
        } else {
          alert(`End date can't be smaller than Start date.`);
          return;
        }
      } else if (valuedatelatest !== "" && endDate === "") {
        apiParams.IDstartdate = valuedatelatest;
        apiParams.IDenddate = dateString;
      } else if (valuedatelatest === "" && endDate !== "") {
        if (dayjs(endDate).isAfter(dayjs(dateStringLast))) {
          apiParams.IDstartdate = dateStringLast;
          apiParams.IDenddate = endDate;
        } else {
          alert(`End date can't be smaller than Start date.`);

          return;
        }
      } else {
        apiParams.IDstartdate = dateStringLast;
        apiParams.IDenddate = dateString;
      }

      GetPostMethodData(BaseURL + "GetNavHistory", apiParams).then((data) => {
        if (data.data != null && data.data.length > 0) {
          setData(DecryptAESdata(data.data));
        }
      });
    }
  };
  return (
    <>
      <Container>
        <Row>
          <Col sm={12}>
            <section className="navs-and-dividends-section">
              <div className="container-fluid p-0">
                <div className="tab-content sub-content" id="pills-tabContent">
                  <div
                    className="tab-pane nav-tab fade show active"
                    id="pills-nav"
                    role="tabpanel"
                  >
                    <div className="container">
                      <div
                        className="tab-content sub-content"
                        id="nav-tabContent"
                      >
                        <div
                          className="tab-pane fade show active"
                          id="pills-latest-nav"
                          role="tabpanel"
                        >
                          {/* <h2>NAV History</h2> */}
                          <div className="tile inner-tab" id="">
                            <ul
                              className="nav nav-tabs nav-justified"
                              role="tablist"
                            >
                              <li
                                className="nav-item"
                                data-value="equity"
                                onClick={(e) => handleChange(e)}
                                role="presentation"
                              >
                                <a
                                  className={`nav-link ${activeTab === "Equity" ? "active" : ""}`}
                                  id="equity-schemes-tab"
                                  data-toggle="tab"
                                  href="#equity-schemes"
                                  role="tab"
                                  aria-controls="equity-schemes"
                                  aria-selected="true"
                                >
                                  Equity
                                </a>
                              </li>
                              <li
                                className="nav-item"
                                data-value="fixedincome"
                                onClick={(e) => handleChange(e)}
                                role="presentation"
                              >
                                <a
                                  className={`nav-link ${activeTab === "fixedincome" ? "active" : ""}`}
                                  id="arbitrage-schemes-tab"
                                  data-toggle="tab"
                                  href="#arbitrage-schemes"
                                  role="tab"
                                  aria-controls="arbitrage-schemes"
                                  aria-selected="false"
                                >
                                  Fixed Income
                                </a>
                              </li>
                              <li
                                className="nav-item"
                                data-value="Hybrid"
                                onClick={(e) => handleChange(e)}
                                role="presentation"
                              >
                                <a
                                  className={`nav-link ${activeTab === "Hybrid" ? "active" : ""}`}
                                  id="debt-schemes-tab"
                                  data-toggle="tab"
                                  href="#debt-schemes"
                                  role="tab"
                                  aria-controls="debt-schemes"
                                  aria-selected="false"
                                >
                                  Hybrid
                                </a>
                              </li>
                            </ul>

                            <div className="tab-content inner-content">
                              <div
                                className="tab-pane latest-nav-tab fade show active"
                                id="equity-schemes"
                                role="tabpanel"
                                aria-labelledby="equity-schemes-tab"
                              >
                                <div className="header-wrapper">
                                  {/* <form action=""> */}
                                  <div className="header-container">
                                    <div className="form-container">
                                      <label htmlFor="first-dropdown">
                                        Select Fund
                                      </label>

                                      <div className="select-container">
                                        <select
                                          id="first-dropdown"
                                          className="fund-selector"
                                          onChange={handleChangeFundName}
                                          value={selectedOptionFundCode}
                                        >
                                          <option value="">
                                            Please Select Fund
                                          </option>
                                          {dataDropFund &&
                                            dataDropFund.map(
                                              ({ schemecode, schemename }) => (
                                                <option value={schemecode}>
                                                  {schemename}
                                                </option>
                                              ),
                                            )}
                                        </select>
                                        <i
                                          className="fa fa-caret-down"
                                          aria-hidden="true"
                                        ></i>
                                      </div>

                                      {showAdditionalDropdowns && (
                                        <div>
                                          <label htmlFor="second-dropdown">
                                            Select Plan
                                          </label>
                                          <div className="select-container">
                                            <select
                                              id="second-dropdown"
                                              className="fund-selector"
                                              onChange={handleChangeFundCode}
                                              value={selectedOptionFundtype}
                                            >
                                              <option value="">
                                                Please Select Plan
                                              </option>
                                              {DropdownFundCode &&
                                                DropdownFundCode.map(
                                                  ({ PlanType }) => (
                                                    <option value={PlanType}>
                                                      {PlanType}
                                                    </option>
                                                  ),
                                                )}
                                            </select>
                                            <i
                                              className="fa fa-caret-down"
                                              aria-hidden="true"
                                            ></i>
                                          </div>
                                          <label htmlFor="third-dropdown">
                                            Select Option
                                          </label>
                                          <div className="select-container">
                                            {selectedOptionFundtype === "" ? (
                                              <select
                                                id="third-dropdown"
                                                className="fund-selector"
                                                onChange={
                                                  handleChangeOptiinDesc
                                                }
                                                value={optiondesc}
                                              >
                                                <option value="">
                                                  Please Select Option
                                                </option>
                                              </select>
                                            ) : (
                                              <select
                                                id="third-dropdown"
                                                className="fund-selector"
                                                onChange={
                                                  handleChangeOptiinDesc
                                                }
                                                value={optiondesc}
                                              >
                                                <option value="">
                                                  Please Select Option
                                                </option>
                                                {DropdownFundType &&
                                                  DropdownFundType.map(
                                                    ({
                                                      SchemeCode,
                                                      OptionDesc,
                                                    }) => (
                                                      <option
                                                        value={SchemeCode}
                                                      >
                                                        {OptionDesc}
                                                      </option>
                                                    ),
                                                  )}
                                              </select>
                                            )}

                                            <i
                                              className="fa fa-caret-down"
                                              aria-hidden="true"
                                            ></i>
                                          </div>
                                        </div>
                                      )}
                                    </div>

                                    <div className="cale" id="datedrop">
                                      <LocalizationProvider
                                        dateAdapter={AdapterDayjs}
                                      >
                                        <DemoContainer
                                          components={[
                                            "DatePicker",
                                            "DatePicker",
                                          ]}
                                        >
                                          <DatePicker
                                            label="Start Date"
                                            value={StartDate}
                                            disableFuture // Disable future dates
                                            format="DD/MMM/YYYY"
                                            onChange={(StartDatenew) =>
                                              handleChangedate(StartDatenew)
                                            }
                                            inputProps={{
                                              placeholder: "Select Date",
                                            }} // Add placeholder
                                          />
                                          <DatePicker
                                            label="End Date"
                                            value={valuedate}
                                            disableFuture // Disable future dates
                                            format="DD/MMM/YYYY"
                                            onChange={(newValue) =>
                                              handleChangedateEnd(newValue)
                                            }
                                            inputProps={{
                                              placeholder: "Select Date",
                                            }} // Add placeholder
                                          />
                                        </DemoContainer>
                                      </LocalizationProvider>
                                    </div>
                                    <div className="export-excel">
                                      <img
                                        src={execl}
                                        onClick={() =>
                                          exportToExcel(data, columns)
                                        }
                                        alt="export-excel"
                                      ></img>
                                    </div>
                                  </div>
                                  {/* </form> */}
                                </div>
                                {optiondesc != "" ? (
                                  <div className="btn-go">
                                    <button
                                      onClick={buttonGo}
                                      aria-label="view nav button"
                                    >
                                      VIEW NAV
                                    </button>
                                  </div>
                                ) : (
                                  <div></div>
                                )}
                                {/* {currentTableData && currentTableData.length > 0 && (
                                                                    <Pagination
                                                                        className="pagination-data"
                                                                        showTotal={(total, range) =>
                                                                            `Showing ${range[0]}-${range[1]} of ${total}`
                                                                        }
                                                                        total={data.length != null ? data.length : 0}
                                                                        current={current}
                                                                        pageSize={size}
                                                                        showSizeChanger={false}
                                                                    />
                                                                )} */}
                                <div className="funds-container">
                                  {/* {currentTableData && currentTableData.length > 0 ? ( */}
                                  <div className="table-responsive">
                                    <table className="table">
                                      <thead>
                                        <tr>
                                          <td>Scheme Name</td>
                                          <td>NAV Date</td>
                                          <td>NAV</td>
                                        </tr>
                                      </thead>
                                      {/* {(data === null) ? <div className="errorMsg"><h3></h3></div> : ''} */}
                                      <tbody>
                                        {/* {(currentTableData === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''} */}
                                        {currentTableData &&
                                          currentTableData.map(
                                            ({
                                              scheme_name,
                                              Nav,
                                              navdate,
                                              isin,
                                            }) => (
                                              <tr>
                                                <td>{scheme_name}</td>
                                                <td>{navdate}</td>
                                                <td>{Nav}</td>
                                              </tr>
                                            ),
                                          )}
                                        {loadingshow ? (
                                          <div className="textcentervertex">
                                            <img
                                              src={animation}
                                              alt="Loading"
                                            />
                                            <div className="model_popup">
                                              Please Wait...
                                            </div>
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                  {/* ) : (
                                                                   <h5 className="errormsgComNew">No Data Available !!!</h5>
                                                                   )} */}
                                </div>

                                {['LD', 'SD', 'FF', 'IF'].includes(selectedOptionFundCode) && (
                                                                <div className="note-section" style={{ marginTop: '16px', padding: '12px 16px', background: '#f8f9fa', borderLeft: '4px solid #0473ea', fontSize: '14px' }}>
                                                                <strong>Note:</strong>{' '}
                                                                {selectedOptionFundCode === 'LD' && 'JM Ultra Short to Short Term Fund (Erstwhile known as JM Low Duration Fund)'}
                                                                {selectedOptionFundCode === 'SD' && 'JM Short Term Fund (Erstwhile known as JM Short Duration Fund)'}
                                                                {selectedOptionFundCode === 'FF' && 'JM Dynamic Term Fund (Erstwhile known as JM Dynamic Bond Fund)'}
                                                                {selectedOptionFundCode === 'IF' && 'JM Medium to Long Term Fund (Erstwhile known as JM Medium to Long Duration Fund)'}
                                                                </div>
                                                            )}

                                {currentTableData &&
                                  currentTableData.length > 0 && (
                                    <Pagination
                                      align="end"
                                      className="pagination-data"
                                      showTotal={(total, range) =>
                                        `Showing ${range[0]}-${range[1]} of ${total}`
                                      }
                                      onChange={PaginationChange}
                                      total={
                                        data.length != null ? data.length : 0
                                      }
                                      current={current}
                                      pageSize={size}
                                      showTitle={false}
                                      showSizeChanger={false}
                                      itemRender={PrevNextArrow}
                                    />
                                  )}

                                {/* {currentTableData == null && (
                                                                    <div className="textcentervertex">
                                                                        <img src={animation} alt="Loading" />
                                                                        <div className="model_popup">Please Wait...</div>


                                                                    </div>
                                                                )
                                                                } */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default NavHistory;
